"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = void 0;
const Env = __importStar(require("../env"));
const Mod = __importStar(require("../mod"));
const inspect_1 = require("../utils/inspect");
const Value = __importStar(require("../value"));
function evaluate(mod, env, exp) {
    switch (exp.kind) {
        case "Exp.v": {
            const { name } = exp;
            return lookup(mod, env, name, {
                on_not_found: (name) => {
                    throw new Error(`undefined name: ${name}`);
                },
            });
        }
        case "Exp.fn": {
            const { name, ret } = exp;
            return Array.of(Value.fn({ name, exp: ret, env, mod }));
        }
        case "Exp.ap": {
            const result = evaluate(mod, env, exp.target);
            if (result.length !== 1)
                throw new Error(`target of Exp.ap should evaluates only one value.\n` +
                    `target: ${(0, inspect_1.inspect)(exp.target)}\n`);
            const target = result[0];
            const args = exp.args.flatMap((arg) => evaluate(mod, env, arg));
            return do_ap(target, args);
        }
        case "Exp.str": {
            const { value } = exp;
            return Array.of(Value.str(value));
        }
        case "Exp.pattern": {
            const { label, value } = exp;
            return Array.of(Value.pattern(label, value));
        }
        case "Exp.grammar": {
            const { name, choices } = exp;
            return Array.of(Value.grammar(name, { choices, mod, env }));
        }
    }
}
exports.evaluate = evaluate;
function lookup(mod, env, name, opts) {
    const values = Env.lookup(env, name);
    if (values)
        return values;
    const exp = Mod.lookup(mod, name);
    if (exp)
        return evaluate(mod, env, exp);
    opts.on_not_found(name);
}
function do_ap(target, args) {
    if (target.kind === "Value.fn") {
        return Value.Closure.apply(target.ret_cl, args);
    }
    else {
        throw new Error(`expecting target to be Value.fn\n` + `target: ${(0, inspect_1.inspect)(target)}\n`);
    }
}
//# sourceMappingURL=exp-evaluate.js.map